module.exports = __webpack_public_path__ + "img/sfs_background.bdda46f9.png";